import CommonInputText from './CommonInputText';

export { CommonInputText };
